export class PenFormData {
    public startNumber: number | undefined;
    public numOfPens: number | undefined;
    public capacity: number | undefined;
    public letter: string | undefined;
}
